import { render, staticRenderFns } from "./CourseValueMapper.vue?vue&type=template&id=83506f1c&scoped=true"
import script from "./CourseValueMapper.vue?vue&type=script&lang=js"
export * from "./CourseValueMapper.vue?vue&type=script&lang=js"
import style0 from "./CourseValueMapper.vue?vue&type=style&index=0&id=83506f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83506f1c",
  null
  
)

export default component.exports